import React from 'react';
import PropTypes from 'prop-types';

function Play({ size = 40, className, onClick }) {
  return (
    <svg className={className} width={size} height={size} onClick={onClick} style={{cursor: `pointer`}} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="20" fill="#34B642"/>
      <path d="M16 13V27L27 20L16 13Z" fill="white"/>
    </svg>
  )
}

Play.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired
}

export default Play;
